// extracted by mini-css-extract-plugin
module.exports = {"LoginFormulari":"LoginFormulari_LoginFormulari__3X_jE","LoginFormulariButton":"LoginFormulari_LoginFormulariButton__1j_8f"};